import React, { useEffect, useState } from 'react';

export default function NpsAnswer({ value, questionId, onChange, sourceId, checked }) {
  const [active, setActive] = useState(checked === value);

  useEffect(() => {	
	setActive(checked === value);
	  }, [checked, value]);

  const handleClickStar = () => {
    onChange?.(sourceId, questionId, value);
  };

  return (
    <div className="inline">
      <input
        name={sourceId + "-" + questionId + "-nps"}
        id={sourceId + "-" + questionId + "-nps" + value}
        type="radio"
        value={value}
        onClick={handleClickStar}
		onChange={handleClickStar}
        checked={active}
      />
      <label htmlFor={sourceId + "-" + questionId + "-nps" + value} className="radio-inline">
        {value}
      </label>
    </div>
  );
}
